import BigNumber from 'bignumber.js'
import pools from 'config/constants/pools'
import useRefresh from 'hooks/useRefresh'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SousTotalBal } from 'state/pools/fetchPools'
import { getBalanceNumber } from 'utils/formatBalance'
import { QuoteToken } from '../config/constants/types'
import { fetchFarmsPublicDataAsync, fetchPoolsUserDataAsync } from './actions'
import { Farm, Pool, State } from './types'

const ZERO = new BigNumber(0)
const realPools = pools.filter((pool) => pool.sousId < 99)
const votePools = pools.filter((pool) => pool.sousId >= 99)

export const useFetchPublicData = () => {
  // const dispatch = useDispatch()
  // const { slowRefresh } = useRefresh()
  // useEffect(() => {
  //   dispatch(fetchFarmsPublicDataAsync())
  //   // dispatch(fetchPoolsPublicDataAsync())
  // }, [dispatch, slowRefresh])
}

// Farms

export const useFarms = (): Farm[] => {
  const farms = useSelector((state: State) => state.farms.data)
  return farms
}

export const useFarmFromPid = (pid): Farm => {
  const farm = useSelector((state: State) => state.farms.data.find((f) => f.pid === pid))
  return farm
}

export const useFarmFromSymbol = (lpSymbol: string): Farm => {
  const farm = useSelector((state: State) => state.farms.data.find((f) => f.lpSymbol === lpSymbol))
  return farm
}

export const useFarmUser = (pid) => {
  const farm = useFarmFromPid(pid)

  return {
    allowance: farm.userData ? new BigNumber(farm.userData.allowance) : new BigNumber(0),
    tokenBalance: farm.userData ? new BigNumber(farm.userData.tokenBalance) : new BigNumber(0),
    stakedBalance: farm.userData ? new BigNumber(farm.userData.stakedBalance) : new BigNumber(0),
    earnings: farm.userData ? new BigNumber(farm.userData.earnings) : new BigNumber(0),
    nextHarvest: farm.userData ? new BigNumber(farm.userData.nextHarvest) : new BigNumber(0),
  }
}

// Pools

export const usePools = (account): Pool[] => {
  const { fastRefresh } = useRefresh()
  const dispatch = useDispatch()
  useEffect(() => {
    if (account) {
      dispatch(fetchPoolsUserDataAsync(account))
    }
  }, [account, dispatch, fastRefresh])

  const poolz = useSelector((state: State) => state.pools.data)
  return poolz
}

export const usePoolFromPid = (sousId): Pool => {
  const pool = useSelector((state: State) => state.pools.data.find((p) => p.sousId === sousId))
  return pool
}

export const useAllPools = (n, m): Pool[] => {
  const poolz = []
  /* eslint-disable react-hooks/rules-of-hooks */
  for (let i = 0 + m; i < n + m; i++) {
    poolz.push(usePoolFromPid(i))
  }
  /* eslint-enable react-hooks/rules-of-hooks */
  return poolz
}

// Prices

export const usePriceWavax = (): BigNumber => {
  const pid = 0 // 0
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceWethUsdc = (): BigNumber => {
  const pid = 1 // 1
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceBtc = (): BigNumber => {
  const pid = 2 // 2
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceJoe = (): BigNumber => {
  const pid = 3 // 3
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceWavaxUsdc = (): BigNumber => {
  const pid = 5 // 5
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceBnbBusd = (): BigNumber => {
  const pid = 7 // 7
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceWethWavax = (): BigNumber => {
  const pid = 8 // 8
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceUsdcUsdt = (): BigNumber => {
  const pid = 9 // 9
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceCornUsdc = (): BigNumber => {
  const pid = 10 // 10
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceTmtUsdt = (): BigNumber => {
  const pid = 12 // 12
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceBrocUsdt = (): BigNumber => {
  const pid = 21 // 12
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

export const usePriceCakeUsdt = (): BigNumber => {
  const pid = 14 // 14
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote).times(10 ** 12) : ZERO
}

export const usePriceCoin = (): BigNumber => {
  const pid = 21 // 14
  const farm = useFarmFromPid(pid)
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO
}

/* export const usePriceCakeWavax = (): BigNumber => {
  const pid = 16; // 16
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
}

export const usePriceCakeUsdc = (): BigNumber => {
  const pid = 17; // 17
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
}

export const usePriceCakeWeth = (): BigNumber => {
  const pid = 18; // 18
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
}

export const usePriceCakeDai = (): BigNumber => {
  const pid = 19; // 19
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
}

export const usePriceCakeWbtc = (): BigNumber => {
  const pid = 20; // 20
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
}

export const usePriceCakeJoe = (): BigNumber => {
  const pid = 21; // 21
  const farm = useFarmFromPid(pid);
  return farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : ZERO;
} */

export const useTotalValue = (): BigNumber[] => {
  const farms = useFarms()
  const poolz = useAllPools(realPools.length, 1)
  const votes = useAllPools(votePools.length, 99)
  const bnbPrice = usePriceBnbBusd()
  const tmtPrice = usePriceTmtUsdt()
  const cakePrice = usePriceCakeUsdt()
  const cornPrice = usePriceCornUsdc()
  const uuPrice = usePriceUsdcUsdt()
  const wwPrice = usePriceWethWavax()
  const wuPrice = usePriceWethUsdc()
  const wPrice = usePriceWavax()
  const wbtcPrice = usePriceBtc()
  const joePrice = usePriceJoe()

  let value = new BigNumber(0)
  for (let i = 0; i < farms.length; i++) {
    const farm = farms[i]

    if (farm.lpTotalInQuoteToken) {
      if (farm.pid === 4) {
        value = value.plus(uuPrice.times(farm.lpTotalInQuoteToken))
      } else if (farm.quoteTokenSymbol === QuoteToken.WAVAX) {
        value = value.plus(bnbPrice.times(farm.lpTotalInQuoteToken))
      } else if (farm.tokenSymbol === QuoteToken.CAKE && farm.quoteTokenSymbol === QuoteToken.WBTC) {
        value = value.plus(wbtcPrice.times(farm.lpTotalInQuoteToken))
      } else if (farm.tokenSymbol === QuoteToken.CAKE && farm.quoteTokenSymbol === QuoteToken.WETH) {
        value = value.plus(wuPrice.times(farm.lpTotalInQuoteToken).times(10 ** 12))
      } else if (farm.tokenSymbol === QuoteToken.CAKE && farm.quoteTokenSymbol === QuoteToken.JOE) {
        value = value.plus(joePrice.times(farm.lpTotalInQuoteToken))
      } else if (farm.quoteTokenSymbol === QuoteToken.CAKE) {
        value = value.plus(cakePrice.times(farm.lpTotalInQuoteToken))
      } else if (farm.pid === 9) {
        // USDC.e-USDT.e
        value = value.plus(uuPrice.times(farm.lpTotalInQuoteToken).times(10 ** 12))
      } else {
        value = value.plus(farm.lpTotalInQuoteToken) // USDC etc
      }
    }
  }
  const farmPoolsValue = value
  for (let i = 0; i < poolz.length; i++) {
    const pool = poolz[i]
    const bal = getBalanceNumber(SousTotalBal(i + 1))

    if (bal) {
      if (pool.stakingTokenName === 'CORN') {
        value = value.plus(cornPrice.times(bal).times(10 ** 12))
      } else if (pool.stakingTokenName === 'TMT') {
        value = value.plus(tmtPrice.times(bal).times(10 ** 12))
      } else if (pool.stakingTokenName === QuoteToken.CAKE) {
        value = value.plus(cakePrice.times(bal))
      } else {
        value = value.plus(bal) // USDC etc
      }
    }
  }
  const divValue = new BigNumber(value.toNumber() - farmPoolsValue.toNumber())
  for (let i = 0; i < votes.length; i++) {
    const vote = votes[i]
    const bal = getBalanceNumber(SousTotalBal(i + 99))

    if (bal) {
      if (vote.stakingTokenName === 'CORN') {
        value = value.plus(cornPrice.times(bal).times(10 ** 12))
      } else if (vote.stakingTokenName === 'TMT') {
        value = value.plus(tmtPrice.times(bal).times(10 ** 12))
      } else if (vote.stakingTokenName === QuoteToken.CAKE) {
        value = value.plus(cakePrice.times(bal))
      } else {
        value = value.plus(bal) // USDC etc
      }
    }
  }
  const voteValue = new BigNumber(value.toNumber() - farmPoolsValue.toNumber() - divValue.toNumber())
  const output = []
  output.push(value.toString() === Infinity.toString() ? new BigNumber(0) : value)
  output.push(farmPoolsValue.toString() === Infinity.toString() ? new BigNumber(0) : farmPoolsValue)
  output.push(divValue.toString() === Infinity.toString() ? new BigNumber(0) : divValue)
  output.push(voteValue.toString() === Infinity.toString() ? new BigNumber(0) : voteValue)
  return output
}
